import React, { Fragment } from 'react';
import {
    ShowButton,
    SimpleShowLayout,
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    EditButton,
    ShowController,
    ShowView,
    SelectInput,
    SimpleForm,
    TextInput,
    Filter,
    FormDataConsumer,
    ArrayInput,
    SimpleFormIterator,
    ImageField,
    ArrayField,
    BooleanField,
    BooleanInput,
    ImageInput,
    SelectArrayInput,
    NumberInput,
    NumberField,
    ReferenceInput,
    ReferenceField,
    TopToolbar,
    AutocompleteInput,
    Show,
    useRecordContext,
} from 'react-admin';

import { Stack, Button, Box, Grid, Paper, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import { Link } from 'react-router-dom'
import BlockViewer from '../editor/BlockViewer'
import JavascriptInput from '../component/JavascriptInput'
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import client from '../common/client';
import {getLoginToken, getSelectedProject} from '../common/common.js'

import Help from '../component/Help'

const ScreenFilter = props => (
    <Filter {...props}>
        <TextInput resettable label="Screen Name" source="name" alwaysOn />
    </Filter>
);

export const ScreenList = props => {
    return (
        <List title="Screen" {...props} filters={<ScreenFilter />}
            exporter={false}
            filter={{project_id:getSelectedProject()}}
            perPage={100}
        >
            <Datagrid>
                <TextField label="ID" source="id" />
                <TextField label="Screen Name" source="name" />
                <BooleanField label="Start Screen" source="splash" />
                <ReferenceField linkType='edit' label="Header" source="header_block_id" reference="block" sortable={false}>
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField linkType='edit' label="Footer" source="footer_block_id" reference="block" sortable={false}>
                    <TextField source="name" />
                </ReferenceField>
                <ShowButton />
                <EditButton />
            </Datagrid>
        </List>
    )
};

const ScreenTitle = ({ record }) => {
    return <span>Screen {record ? `"${record.name}"` : ''}</span>;
};

const required = (message = 'Required') =>
    value => value ? undefined : message;
const maxLength = (max, message = 'Too Long') =>
    value => value && value.length > max ? message : undefined;
const validateRequireAndLength = [required(), maxLength(100)];

export const ScreenCreate = props => (
    <Create title={<ScreenTitle />} {...props} mutationMode='pessimistic'>
        <SimpleForm>
            <TextInput resettable label="Screen Name" source="name" validate={validateRequireAndLength} />
            <BooleanInput label="Splash(Slash scdreen is only one in a project" source="splash" defaultValue={false} />
            <ReferenceInput label="Header Block" source="header_block_id" reference="block" filter={{project_id:getSelectedProject()}}>
                <SelectInput optionText="name" />
            </ReferenceInput>
            <ReferenceInput label="Footer Block" source="footer_block_id" reference="block" filter={{project_id:getSelectedProject()}}>
                <SelectInput optionText="name" />
            </ReferenceInput>
            <ArrayInput label="Block List" source="block_list">
                <SimpleFormIterator>
                    <SelectInput resettable label="Type" source="type" validate={validateRequireAndLength}
                        choices={[{ id: 'sketch' }, { id: 'custom' }, { id: 'list' }, { id: 'combinedList' }]} optionText="id" optionValue="id"
                    />
                    <FormDataConsumer>
                        {({ formData, scopedFormData, getSource, ...rest }) =>
                            (scopedFormData && scopedFormData.type == 'sketch') && (
                                <Grid container spacing={2}>
                                    <Grid item>
                                        <ReferenceInput label="Block" source={getSource('block_id')} reference="block" filter={{project_id:getSelectedProject()}}>
                                            <SelectInput optionText="name" validate={validateRequireAndLength} />
                                        </ReferenceInput><br />
                                        <TextInput resettable label="If contidion" source={getSource('ifcondition')} />
                                    </Grid>
                                    <Grid item>
                                        <BlockViewer key={scopedFormData.block_id} showEditButton={true} block_id={scopedFormData.block_id} />
                                    </Grid>
                                </Grid>
                            )}
                    </FormDataConsumer>

                    <FormDataConsumer>
                        {({ formData, scopedFormData, getSource, ...rest }) =>
                            (scopedFormData && scopedFormData.type == 'custom') && (
                                <Box>
                                    <TextInput resettable label="Custom Name String" source={getSource('customString')} />
                                    <br />
                                    <TextInput resettable label="If contidion" source={getSource('ifcondition')} />
                                </Box>
                            )}
                    </FormDataConsumer>

                    <FormDataConsumer>
                        {({ formData, scopedFormData, getSource, ...rest }) =>
                            (scopedFormData && scopedFormData.type == 'list') && (
                                <Box>
                                    <TextInput resettable label="Target Array" source={getSource('targetArray')} />
                                    <br />
                                    <TextInput resettable label="Max Count" source={getSource('maxCount')} type="number" />
                                    <br />
                                    <ReferenceInput label="Block" source={getSource('block_id')} reference="block">
                                        <SelectInput optionText="name" validate={validateRequireAndLength} />
                                    </ReferenceInput>
                                </Box>
                            )}
                    </FormDataConsumer>

                    <FormDataConsumer>
                        {({ formData, scopedFormData, getSource, ...rest }) =>
                            (scopedFormData && scopedFormData.type == 'combinedList') && (
                                <Box>
                                    <TextInput resettable label="Target Array" source={getSource("targetArray")} />
                                    <br />
                                    <ArrayInput label="Combined Block List" source={getSource("combined_block_list")}>
                                        <SimpleFormIterator>
                                            <ReferenceInput label="Block" source={'block_id'} reference="block">
                                                <SelectInput optionText="name" validate={validateRequireAndLength} />
                                            </ReferenceInput>

                                            <TextInput resettable label="If contidion" source={'ifcondition'} />
                                        </SimpleFormIterator>
                                    </ArrayInput>
                                </Box>
                            )}
                    </FormDataConsumer>
                </SimpleFormIterator>
            </ArrayInput>
        </SimpleForm>
    </Create>
);

const PostEditActions = () => {
    const data = useRecordContext()
    return (
        <TopToolbar>
            {/* <ShowButton basePath={basePath} record={data} /> */}
            {data && data.from_screen_list && data.from_screen_list.map(s => (
                <Box key={s.id}><Button
                    endIcon={<ArrowRightAltIcon />}
                    variant="outlined" component={Link}
                    to={{ pathname: `/screen/${s.id}`, }}>{s.name}</Button>&nbsp;</Box>
            ))}
            {data && data.screen_list && data.screen_list.map((s, index) => {
                if (index < 5)
                    return (
                        <Box key={s.id}><Button
                            startIcon={<ArrowRightAltIcon />}
                            variant="outlined" component={Link}
                            to={{ pathname: `/screen/${s.id}`, }}>{s.name}</Button>&nbsp;</Box>
                    )
                else
                    return <div />
            })}
            <Button variant="outlined" color="primary" component={Link}
                to={{ pathname: `/project/${data && data.project_id}/show`, }}>
                Project Show</Button>&nbsp;
            <Button variant="outlined" color="secondary" component={Link}
                to={{ pathname: `/project/${data && data.project_id}/3`, }}>
                Common Code</Button>

        </TopToolbar>
    )
};

export const ScreenEdit = props => (
    <Edit redirect={false} title={<ScreenTitle />} {...props} mutationMode='pessimistic' actions={<PostEditActions />}>
        <SimpleForm >
            <TextInput resettable label="Screen Name" source="name" validate={validateRequireAndLength} />


            <Box sx={{ width: '100%' }}>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography>Screen Frame Setting</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box >
                            <BooleanInput label="Start Screen(only one in a project" source="splash" defaultValue={false} />
                            <BooleanInput label="Double Back Button(Android Only)" source="double_back_to_finish" defaultValue={false} />

                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={'center'}>
                                <ReferenceInput label="Header Block" source="header_block_id" reference="block" resettable perPage={100} filter={{project_id:getSelectedProject()}}>
                                    <SelectInput optionText="name" />
                                </ReferenceInput>

                                <ReferenceInput label="Footer Block" source="footer_block_id" reference="block" resettable perPage={100} filter={{project_id:getSelectedProject()}}>
                                        <AutocompleteInput optionText="name" />
                                    </ReferenceInput>
                                <ReferenceInput label="Inside Footer Block" source="inside_footer_block_id" reference="block" resettable perPage={100} filter={{project_id:getSelectedProject()}}>
                                        <AutocompleteInput optionText="name" />
                                    </ReferenceInput>
                                <Box>
                                    <Help title="Footer Block" type="button" url='https://devilappbuilder.tistory.com/6' />
                                </Box>
                                <BooleanInput label="Footer Shadow" source="footer_shadow" defaultValue={false} />
                            </Stack>

                            <FormDataConsumer>
                                {({ formData, ...rest }) =>
                                (formData.footer_block_id &&
                                    <BooleanInput label="Fix footer when Keyboard Up(iOS Only)" source="fix_footer" defaultValue={false} />
                                )
                                }
                            </FormDataConsumer>
                            <BooleanInput label="Can Orientation Change" source="orientation_change" defaultValue={false} />
                        </Box>
                    </AccordionDetails>
                </Accordion>
            </Box>


            <Box sx={{ width: '100%' }} mt={2}>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography>Screen Block Setting</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <ArrayInput label="Block List" source="block_list">
                            <SimpleFormIterator>
                                <SelectInput resettable label="Type" source="type" validate={validateRequireAndLength}
                                    choices={[{ id: 'sketch' }, { id: 'custom' }, { id: 'list' }, { id: 'combinedList' }]} optionText="id" optionValue="id"
                                    defaultValue={'sketch'}
                                />
                                <FormDataConsumer>
                                    {({ formData, scopedFormData, getSource, ...rest }) =>
                                        (scopedFormData && scopedFormData.type == 'sketch') && (
                                            <Grid container spacing={2}>
                                                <Grid item>
                                                    <ReferenceInput label="Block" source={getSource('block_id')} reference="block" perPage={100} filter={{project_id:getSelectedProject()}}>
                                                        <SelectInput optionText="name" validate={validateRequireAndLength} />
                                                    </ReferenceInput><br />
                                                    <TextInput resettable label="If contidion" source={getSource('ifcondition')} />
                                                </Grid>
                                                <Grid item>
                                                    <BlockViewer key={scopedFormData.block_id} showEditButton={true} block_id={scopedFormData.block_id} />
                                                </Grid>
                                            </Grid>
                                        )}
                                </FormDataConsumer>

                                <FormDataConsumer>
                                    {({ formData, scopedFormData, getSource, ...rest }) =>
                                        (scopedFormData && scopedFormData.type == 'custom') && (
                                            <Box>
                                                <TextInput resettable label="Custom Name String" source={getSource('customString')} />
                                                <br />
                                                <TextInput resettable label="If contidion" source={getSource('ifcondition')} />
                                            </Box>
                                        )}
                                </FormDataConsumer>

                                <FormDataConsumer>
                                    {({ formData, scopedFormData, getSource, ...rest }) =>
                                        (scopedFormData && scopedFormData.type == 'list') && (
                                            <Box>
                                                <TextInput resettable label="Target Array" source={getSource('targetArray')} />
                                                <br />
                                                <TextInput resettable label="Max Count" source={getSource('maxCount')} type="number" />
                                                <br />
                                                <ReferenceInput label="Block" source={getSource('block_id')} reference="block" perPage={100}>
                                                    <SelectInput optionText="name" validate={validateRequireAndLength} />
                                                </ReferenceInput>
                                            </Box>
                                        )}
                                </FormDataConsumer>

                                <FormDataConsumer>
                                    {({ formData, scopedFormData, getSource, ...rest }) =>
                                        (scopedFormData && scopedFormData.type == 'combinedList') && (
                                            <Box>
                                                <TextInput resettable label="Target Array" source={getSource("targetArray")} />
                                                <br />
                                                <ArrayInput label="Combined Block List" source={getSource("combined_block_list")}>
                                                    <SimpleFormIterator>
                                                        <ReferenceInput label="Block" source={'block_id'} reference="block" perPage={100}>
                                                            <SelectInput optionText="name" validate={validateRequireAndLength} />
                                                        </ReferenceInput>
                                                        <TextInput resettable label="If contidion" source={'ifcondition'} />
                                                    </SimpleFormIterator>
                                                </ArrayInput>
                                            </Box>
                                        )}
                                </FormDataConsumer>
                            </SimpleFormIterator>
                        </ArrayInput>
                    </AccordionDetails>
                </Accordion>
            </Box>


            <Box sx={{ width: '100%' }} mt={2}>
                <JavascriptInput fullWidth={true} label="On Create Javascript" source="javascript_on_create" />
            </Box>
        </SimpleForm>
    </Edit>
);



export const ScreenShow = ({ ...props }) => (
    <Show {...props} title={<ScreenTitle />}>
        <SimpleShowLayout>
            <TextField resettable label="Screen Name" source="name" />
            <BooleanField label="Splash(Slash scdreen is only one in a project" source="splash" />
            <ArrayField label="Block List" source="block_list">
                <Datagrid>
                    <ReferenceField linkType='show' label="Block Name" source="block_id" reference="block" sortable={false} filter={{project_id:getSelectedProject()}}>
                        <TextField label="Name" source="name" />
                    </ReferenceField>
                    <TextField label="Type" source="type" />
                    <TextField label="If contidion" source="ifcondition" />
                </Datagrid>
            </ArrayField>
        </SimpleShowLayout>
    </Show>
);
